<template>
	<el-dialog
		:title="translations.labels.areYouSure"
		:visible.sync="leaveConfirmation.show"
		:show-close="false"
		:close-on-press-escape="false"
		:close-on-click-modal="false"
		width="400px"
	>
		{{ translations.labels.leaveConfirmation }}
		<div slot="footer" class="dialog-footer">
			<el-button
				@click="proceed()"
				type="primary"
				size="medium"
				plain
			>
				{{ translations.labels.continue }}
			</el-button>
			<el-button
				@click="cancel()"
				size="medium"
				plain
			>
				{{ translations.labels.cancel }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import updateLeaveConfirmation from '@/services/mixins/updateLeaveConfirmation'

export default {
    name: 'LeaveConfirmation',
	mixins: [
		updateLeaveConfirmation
	],
	computed: {
		...mapState(['leaveConfirmation'])
	},
	methods: {
		cancel () {
			this.updateLeaveConfirmation(true, false, null)
		},
		proceed () {
			this.redirectTo(this.leaveConfirmation.path)
			this.updateLeaveConfirmation(false, false, null)
		}
	}
}
</script>
